<template>
  <v-layout fluid v-resize="onResize">
    <v-data-table
      :loading="isLoading"
      :headers="
      !isLoading ?
        hasPermsByOrgs([filterHospital])
          ? table.headers
          : table.viewOnlyHeaders : []
      "
      :items="sortableList"
      :sort-desc="true"
      :must-sort="false"
      class="elevation-1 custom-table"
      fixed-header
      style="width: 100%"
      :height="windowSize.y - heightOptions.header - heightOptions.tableFooter"
      hide-default-footer
    >
      <template v-if="isLoading" v-slot:loading>
        Loading items...
      </template>
      <template v-else-if="sortableTotal <= 0" v-slot:no-data>
        No data available
      </template>
      <template v-else-if="sortableTotal > 0" v-slot:body>
        <draggable
          v-model="draggableList"
          tag="tbody"
          handle=".handle"
          @start="dragStart"
          @end="dragEnd"
          :disabled="!hasPermsByOrgs([filterHospital])"
        >
          <tr v-for="(item, index) in draggableList" :key="item.id">
            <td v-if="hasPermEditByOrg(item.org)">
              <v-img
                v-if="hasPermEditByOrg(item.org)"
                class="handle"
                aspect-ratio="1"
                max-height="24"
                max-width="24"
                src="/images/grip-line-icon.png"
              ></v-img>
            </td>
            <td>
              {{ index + 1 }}
            </td>
            <td>
              <tooltip-title :contents="item.contents" key-name="name">
                <template v-slot:content>
                  <v-list-item-content
                    class="d-inline-block text-truncate"
                    style="width: 430px"
                  >
                    <v-list-item-title>
                      {{ getContentByLang(item.contents, 'th') }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ getContentByLang(item.contents, 'en') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </tooltip-title>
            </td>
            <td>
              {{
                dateFmt(item.update_date)
              }}
            </td>
            <td>
              <v-switch
                t-data="status-switch"
                color="primary200Color"
                v-model="item.status"
                :false-value="inActiveStatus"
                :true-value="activeStatus"
                :disabled="!hasPermEditByOrg(item.org)"
                @change="event => handleSwitchStatusChange(event, item.id)"
                class="mb-0 pb-0 custom-switch"
              ></v-switch>
            </td>
            <td v-if="hasPermEditByOrg(item.org)">
              <v-icon
                t-data="sort-action"
                class="px-2 action-icon"
                @click="actionEdit(item)"
                >mdi-format-list-numbered</v-icon
              >
            </td>
          </tr>
        </draggable>
      </template>
      <template v-slot:footer
        ><div class="v-data-footer" style="height: 58px"></div>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
import TooltipTitle from '@/components/TooltipTitle'
import {mapActions, mapState} from 'vuex'
import {symptomaticAreasStatusEnum} from '@/constants/symptomatic-areas'
import {convertDate, hasPermissionsByOrgs} from '@/helper/helper'

import draggable from 'vuedraggable'

export default {
  name: 'SortableTable',
  components: {
    TooltipTitle,
    draggable
  },
  props: {},
  data() {
    return {
      heightOptions: {
        header: 398,
        tableFooter: 59
      },
      windowSize: {
        x: 0,
        y: 0
      },
      activeStatus: symptomaticAreasStatusEnum.ACTIVE,
      inActiveStatus: symptomaticAreasStatusEnum.INACTIVE,
      table: {
        dragging: false,
        headers: [
          {
            text: '',
            align: 'left',
            sortable: false,
            value: 'order',
            width: 60
          },
          {
            text: 'No.',
            align: 'left',
            sortable: false,
            value: 'id',
            width: 34
          },
          {
            text: 'Name',
            align: 'left',
            sortable: false,
            value: 'content',
            width: 430
          },
          {
            text: 'Updated date/time',
            align: 'left',
            sortable: false,
            value: 'update_date',
            width: 196
          },
          {
            text: 'Status',
            align: 'center',
            sortable: false,
            value: 'status',
            width: 65
          },
          {
            text: 'Actions',
            align: 'left',
            sortable: false,
            value: 'actions',
            width: 80
          }
        ],
        viewOnlyHeaders: [
          {
            text: 'No.',
            align: 'left',
            sortable: false,
            value: 'id',
            width: 34
          },
          {
            text: 'Name',
            align: 'left',
            sortable: false,
            value: 'content',
            width: 430
          },
          {
            text: 'Updated date/time',
            align: 'left',
            sortable: false,
            value: 'update_date',
            width: 196
          },
          {
            text: 'Status',
            align: 'center',
            sortable: false,
            value: 'status',
            width: 65
          },
        ]
      }
    }
  },
  computed: {
    draggableList: {
      get() {
        return this.sortableList
      },
      set(val) {
        this.reorderSymptomaticAreasList(val)
      }
    },
    ...mapState('symptomaticAreas', [
      'filterHospital',
      'isLoading',
      'sortableList',
      'sortableTotal',
    ])
  },
  methods: {
    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight}
    },
    dragStart() {
      this.table.dragging = true
    },
    dragEnd() {
      this.table.dragging = false
    },
    hasPermEditByOrg(org) {
      const codenames = org.hasOwnProperty('org_codename') ? org.org_codename : []
      return hasPermissionsByOrgs('CanEditSymptomatic', codenames)
    },
    hasPermsByOrgs: codenames =>
      hasPermissionsByOrgs('CanEditSymptomatic', codenames),
    dateFmt: date => convertDate(date),
    async handleSwitchStatusChange(event, id) {
      const isSuccess = await this.changeStatus({status: event, id: id})
      if (isSuccess) {
        await this.fetchSortableList()
        this.$emit('updateSuccess')
      } else {
        this.$emit('updateFail')
      }
    },
    getContentByLang(contents, lang) {
      const contentsInLang = contents.filter(c => c.code === lang)
      if (contentsInLang.length > 0) {
        return contentsInLang[0].name
      }
      return ''
    },
    async actionEdit(item) {
      await this.setEditOrder(item)
    },
    ...mapActions('symptomaticAreas', [
      'changeStatus',
      'fetchSortableList',
      'reorderSymptomaticAreasList',
      'setEditOrder',
    ])
  }
}
</script>
